<h1 class="modal__header">Please contact our operations support team</h1>
<div class="modal__text">
  <p>DigitalCustomerSupport@massmutual.com We will reply within one business day</p>
  <p>1 (866) 618-7797 9am-6pm EST, Monday-Friday</p>
</div>
<div class="modal__actions">
  <button class="button button--blue button--primary modal__button" (click)="closeModal()">Exit</button>
</div>
